import { Info } from 'lucide-react';
import React, { type HTMLAttributes } from 'react';

import { TailwindLabel } from '../../tailwind';
import { AutoneTooltip } from '../../tailwind/Tooltip';
import { cn } from '../../tailwind/utils';

interface Props extends HTMLAttributes<HTMLDivElement> {
  label: string;
  infoText?: string;
  htmlFor?: string;
  labelIcon?: React.ReactNode;
}

export const CoreMultiselectWrapper = ({
  className,
  children,
  label,
  infoText,
  htmlFor,
  labelIcon,
  ...props
}: Props) => (
  <div className={cn('space-y-1 flex-1', className)} {...props}>
    <TailwindLabel
      className="flex flex-row justify-between items-center text-base font-medium"
      htmlFor={htmlFor}
    >
      <div className="flex flex-row gap-2 items-center">
        {label}
        {labelIcon}
      </div>
      {infoText && (
        <AutoneTooltip text={infoText} className="max-w-[300px]">
          <Info size={14} />
        </AutoneTooltip>
      )}
    </TailwindLabel>
    {children}
  </div>
);
